/* eslint-disable no-restricted-globals */
import { h, render } from 'preact'

import { elements } from '@utils/elements'
import onReady from '@utils/onReady'
import renderSharedUI from '@utils/renderSharedUI'
import DrawerManager from '@features/drawer/DrawerManager'
import ArchivePage from '@features/elastic/components/ArchivePage'

onReady().then(() => {
	renderSharedUI()
	render(
		<ArchivePage pageType="manufacturer" />,
		document.getElementById(elements.manufacturerPage),
	)
	setTimeout(() => {
		window._drawerManager = new DrawerManager()
	}, 50)
})
